import { render, staticRenderFns } from "./ReplaceFile.vue?vue&type=template&id=13a38738&scoped=true&"
import script from "./ReplaceFile.vue?vue&type=script&lang=js&"
export * from "./ReplaceFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a38738",
  null
  
)

export default component.exports